module.exports = __webpack_public_path__ + "img/signup-guide-02-04.c1c0f2f7.png";